import { styled } from '@mui/material/styles';
import Modal from '@mui/material/Modal';

export default styled(Modal)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});
